import React from 'react';
import { Stack, Typography } from '@mui/material';

import { ListCard } from 'components/Card';
import { RowActions } from 'features/procurementSetup/components/RowActions';

export const SettingListItem = ({ label, value, unit, isOverrideScope, isInherited, onEdit }) => {
  return (
    <ListCard p={1.5} aria-label={`Setting ${label}`}>
      <Stack direction="row" alignItems="center" flex={12} minWidth={0} pl={1}>
        <Typography
          variant="body1"
          fontWeight={700}
          fontSize="1rem"
          noWrap
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={onEdit}
        >
          {label}
        </Typography>
      </Stack>

      {isOverrideScope && (
        <Stack justifyContent="center" minWidth={100} pl={2}>
          <Typography variant="caption" fontWeight={700}>
            Source
          </Typography>
          <Typography variant="body2" fontWeight={700}>
            {isInherited ? 'Default' : 'Overridden'}
          </Typography>
        </Stack>
      )}

      <Stack direction="row" alignItems="center" flex={1} position="relative" minWidth={200} pl={2}>
        <Stack>
          <Typography variant="caption" fontWeight={700}>
            Value
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            color={isInherited ? 'text.secondary' : 'text.primary'}
          >
            {unit ? `${value} ${unit}` : value}
          </Typography>
        </Stack>

        <RowActions name={label} onEdit={onEdit} />
      </Stack>
    </ListCard>
  );
};
